/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Group_EditorInputs */



/**
* | output |
* | --- |
* | "Editor" |
*
* @param {Shortcut_Keys_Group_EditorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_group_editor = /** @type {((inputs?: Shortcut_Keys_Group_EditorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Group_EditorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Editeur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Editor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Redattore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактор")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editor")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エディタ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपादक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editor")
	return /** @type {LocalizedString} */ ("Editor")
});